// extracted by mini-css-extract-plugin
export default {"textfield":"teacher_textfield__mRbtg","scrollable":"teacher_scrollable__g5ubW"};